// src/app/shared/services/logger.service.ts
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

export enum LogLevel {
  Debug = 0,
  Info = 1,
  Warn = 2,
  Error = 3,
  Off = 4,
}

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private level: LogLevel = environment.production ? LogLevel.Error : LogLevel.Debug;

  debug(message: string, ...data: any[]): void {
    this.logWithLevel(LogLevel.Debug, message, data);
  }

  info(message: string, ...data: any[]): void {
    this.logWithLevel(LogLevel.Info, message, data);
  }

  warn(message: string, ...data: any[]): void {
    this.logWithLevel(LogLevel.Warn, message, data);
  }

  error(message: string, ...data: any[]): void {
    this.logWithLevel(LogLevel.Error, message, data);
  }

  private logWithLevel(level: LogLevel, message: string, data: any[]): void {
    if (level >= this.level) {
      const timestamp = new Date().toISOString();
      const logPrefix = `[${timestamp}] [${LogLevel[level]}]`;

      switch (level) {
        case LogLevel.Debug:
          console.log(`${logPrefix} ${message}`, ...data);
          break;
        case LogLevel.Info:
          console.info(`${logPrefix} ${message}`, ...data);
          break;
        case LogLevel.Warn:
          console.warn(`${logPrefix} ${message}`, ...data);
          break;
        case LogLevel.Error:
          console.error(`${logPrefix} ${message}`, ...data);
          break;
      }
    }
  }

  setLogLevel(level: LogLevel): void {
    this.level = level;
  }
}
